.Modal-header {
 	border-bottom: 1px solid #E6ECF1;
	margin-bottom: 20px;
	padding-top: 20px;
	padding-bottom: 20px;
	padding-left: 20px;
	padding-right: 20px;
	font-size: 16px;
	font-weight: 500;
	font-family: 'Poppins', sans-serif;
}


.Modal-close {
	border-radius: 50%;
}

.Modal-close:hover {
	background: rgba(108,118,128,0.25)
}
